
export default class FormInputLabel {

    constructor(){


        let fields_group = jQuery('.wp-block-application-form .form-field').has('input[type="text"], input[type="number"], .input-mimic').has('label').addClass('form-field--has-animated-label') ;

        fields_group.find('input, .input-mimic').on('focus',function(e){
            jQuery(this).closest('.form-field').addClass('form-field--has-input');
        });

        fields_group.find('input, .inpu-mimic').on('blur',function(e){
            let text = jQuery(this).val() ;
            if( text == '' ){ jQuery(this).closest('.form-field').removeClass('form-field--has-input'); }
        });

        jQuery.each( fields_group.find('input, .input-mimic'), function( i, elt ) {
            let text = jQuery(elt).val() ;
            if( text != '' ){ jQuery(this).closest('.form-field').addClass('form-field--has-input'); }
        });

    }

}